import { Button, Grid, Typography } from "@mui/material"
import { ModalComponent } from "../../../../../../../components/modal"
import animationReferAndWin from "../../../../../../../assets/animation/refer.json"

import useAuth from "../../../../../../../context/auth"
import Lottie from "react-lottie"

interface Props {
    open: boolean,
    onClose: () => void,
    reason?: string | null
}

const referAndWinOptions = {
    loop: true,
    autoplay: true,
    animationData: animationReferAndWin,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};

export const ModalReferAndWin = ({
    onClose,
    open,
    reason
}: Props) => {
    const { user, setTab } = useAuth()

    return (
        <ModalComponent
            open={open}
            withoutHeader
            onClose={onClose}
        >
            <Grid
                width={"100%"}
                display={"flex"}
                direction={"column"}
                gap={"1.7rem"}
                alignItems={"center"}
            >
                <Typography textAlign={"center"} fontSize={"1.6rem"} fontWeight={700}>SUA SOLICITAÇÃO DE CRÉDITO NÃO FOI APROVADA</Typography>
                <Typography textAlign={"center"} fontSize={"1.6rem"} fontWeight={400}>{reason}</Typography>

                <Typography textAlign={"center"} fontSize={"2rem"} fontWeight={400}>Você pode <strong>ganhar R$ 20 indicando GYROO</strong> para seus amigos.</Typography>

                <div style={{ width: "15rem", height: 'auto', marginBottom: "-2rem" }}>
                    <Lottie options={referAndWinOptions} />
                </div>

                <Button
                    variant="contained"
                    sx={{
                        width: "100%",
                        maxWidth: "27.5rem",
                        height: "4rem",
                    }}
                    onClick={() => {
                        setTab(1)
                        onClose()
                    }}
                >Indique e ganhe</Button>

            </Grid>
        </ModalComponent>
    )
}